import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

// Pages
import HomePage from './pages/Home';
import ScanResultPage from './pages/ScanResult';

// Components
import Header from './components/Header';
import Footer from './components/Footer';

// Create a theme instance
const theme = createTheme({
  palette: {
    primary: {
      main: '#2e7d32', // Green
    },
    secondary: {
      main: '#f44336', // Red
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
    h1: {
      fontSize: '2.2rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '1.8rem',
      fontWeight: 500,
    },
  },
});

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Header />
      <main style={{ minHeight: 'calc(100vh - 140px)', padding: '2rem 0' }}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/scan/:scanId" element={<ScanResultPage />} />
        </Routes>
      </main>
      <Footer />
    </ThemeProvider>
  );
};

export default App; 